<template>
  <span class="cancel-shipment-detail" v-if="isVisible()">
    <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('customerService.shipment.cancelShipmentDetail')" placement="top-start">
        <i class="fa fa-ban icon-action cancel-shipment-detail-icon" type="primary" size="mini" @click="dialogVisible = true"></i>
    </el-tooltip>
    <el-dialog
        v-on:open="handleOpen"
        :title="$t('customerService.shipment.cancelShipmentDetails')"
        :visible.sync="dialogVisible"
        width="38%"
        class="dialog-with-cols cancel-shipment-detail-reason-dialog"
        append-to-body
        :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="right" label-width="80px" size="mini">
        <el-row :gutter="10">
          <el-col :md="24" :sm="24" :xs="24">
            <span class="span-small-list">
              {{ `${$t('customerService.shipment.cancelShipmentDetails')}: ${shipmentDetail.productCode} - ${shipmentDetail.productDescription}` }}
            </span>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24">
            <span class="span-small-list">
              {{ `${$t('customerService.shipment.totalUnits')}: ${shipmentDetail.numberUnits} -`}}
              {{ `${$t('customerService.shipment.dimensions')}: ${shipmentDetail.length} x ${shipmentDetail.width} x ${shipmentDetail.height}` }}
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('customerService.shipment.reason')" prop="shipmentCancelReasonId">
               <el-select
                filterable
                v-model="shipmentCancelReasonSelected"
                value-key="id"
                :loading="loading"
                id="form-reason-select"
                ref="reason-select"
                @change="selectReason"
              >
                <el-option
                  v-for="reason in shipmentCancelReasonList"
                  :key="reason.id"
                  :label="reason.name"
                  :value="reason"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="10" v-if="shipmentCancelReasonSelected.description">
        <el-col :md="24" :sm="24" :xs="24">
          <span class="span-small-list"> {{ shipmentCancelReasonSelected.description }} </span>
        </el-col>
      </el-row>
      <div
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction cancel-shipment-reason-dialog-footer"
      >
        <el-button
            type="primary"
            class="cancel-shipment-detail-button"
            @click="submitForm()"
            size="mini"
        >{{ $t('customerService.shipment.cancelShipmentDetail') }}</el-button>
        <el-button
            class="close-cancel-shipment-detail-button"
            @click="dialogVisible = false"
            size="mini"
        >{{ $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import selectService from '@/api/selectService';

export default {
  name: 'ShipmentDetailCancelButton',
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    },
    shipmentDetail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      shipmentCancelReasonList: [],
      shipmentCancelReasonSelected: {},
      loading: false,
      form: {
        shipmentId: this.shipmentId,
        shipmentDetailId: this.shipmentDetail.id,
        shipmentCancelReasonId: null
      },
      formRules: {
        shipmentCancelReasonId: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.cancellationReasonRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    isVisible() {
      const hasShipmentClosedOrCancelled = this.shipmentStatus === constants.SHIPMENT.STATUS[5].value || this.shipmentStatus === constants.SHIPMENT.STATUS[6].value;
      const hasPermission = this.$can(this.permissions.BILLING.CANCEL_SHIPMENT);
      return !hasShipmentClosedOrCancelled && this.shipmentDetail.active && hasPermission;
    },
    resetForm() {
      this.shipmentCancelReasonSelected = {};
      this.form.shipmentId = this.shipmentId;
      this.form.shipmentDetailId = this.shipmentDetail.id;
      this.form.shipmentCancelReasonId = null;
      this.$nextTick(() => {
        this.$refs.form.$el[0].focus();
      });
    },
    handleOpen() {
      this.searchCancelReasons();
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    searchCancelReasons() {
      this.shipmentCancelReasonList = [{}];
      this.loading = true;
      selectService.getList(apiConstants.END_POINTS.BILLING.SHIPMENTS_CANCEL_REASON).then((response) => {
        if (response instanceof Array) {
          this.shipmentCancelReasonList = this.shipmentCancelReasonList.concat(response);
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    selectReason(reason) {
      this.form.shipmentCancelReasonId = reason.id;
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch('shipment/cancelDetail', { ...this.form });
        if (response.message) {
          this.$message.success(response.message);
        }
        this.dialogVisible = false;
        await this.$store.dispatch('shipment/searchDetails', {});
        this.$store.dispatch('shipment/searchHeader', this.shipmentId);
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.cancel-shipment-detail {
  .fa {
    font-size: 15px;
  }
}
.cancel-shipment-detail-reason-dialog {
  .el-form-item__content {
    .el-select {
      width: 97%;
    }
  }
}
</style>
